module.exports = __webpack_public_path__ + "891a4775d41f931b1851793ed2a4473a.svg";